<template>
    <div class="wb-reconcile-section">
        <section v-loading="loading" aria-live="polite"></section>
        <div class="suppo-reconcile-toolbar">
            <div class="toolbar-left-group">
                <el-button type="danger" @click="editRec" :disabled="cfmBool || saving" icon="iconfont icon-fapiaoguanli" size="small">
                    <span>{{ $LANG('', '对账') }}</span>
                </el-button>
                <el-button type="primary" icon="iconfont icon-daochu" @click="expExcel" size="small">
                    <span>{{ $LANG('', '导出当前页面') }}</span>
                </el-button>
            </div>
        </div>
        <el-table  :data="tabData"
            border
            disabled-hover
            class="custom-table-border wb-reconcile-main"
            :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
            header-cell-class-name="clearPadding"
            style="overflow:auto;margin-top:1px;"
            size="small"
            :height="tabHeight"
            :row-key="getRowKey"
            ref="tabref"
            @current-change="rowClick"
            v-loading="v_loading"
            :element-loading-text="$LANG('', '数据加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(100, 100, 100, 0.8)"
            show-summary
            :summary-method="getAmt"
            highlight-current-row>
            <el-table-column :label="$LANG('', '序号')" type="index" width="50" fixed>
                <el-table-column :label="$LANG('', '序号')" type="index" width="50" fixed align="center">
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff">
                            <el-tooltip :content="$LANG('', ' 清除条件')" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column  v-for="(item,index ) in payCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.notnull=='Y'"> </span>

                        <el-select v-if="item.key=='FCHK'" @change="qryTabData" v-model="v_inputrow[item.key]" size="mini" :placeholder="$LANG('', '请选择')" filterable clearable style="width:100%; " >
                            <el-option :label="$LANG('', '是')" value="Y"  ></el-option>
                            <el-option :label="$LANG('', '否')" value="N"  ></el-option>
                        </el-select>
                        <el-checkbox v-else-if="item.key=='SEL'" @change="selChg" size="mini"  v-model="v_select" true-label="Y" false-label="N"></el-checkbox>
                        <el-date-picker v-else-if="item.edcss=='date'" @change="qryTabData" size="mini"  type="date" :clearable="false" v-model="v_inputrow[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                        <el-input type="number" :placeholder="$LANG('', '数字框')"  @keyup.enter.native="qryTabData" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_inputrow[item.key]" style="width:100%"> </el-input>
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryTabData"  v-model="v_inputrow[item.key]" size="mini" :placeholder="$LANG('', '请输入')" ></el-input>
                    </template>
                    <template  slot-scope="scope" >
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-link v-else-if="item.key=='FINVNO'" :underline="false" @click="repShow2(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-tag  v-else-if="item.key=='FCHK'&&scope.row['FCHK']=='Y'" size="mini" type="success" effect="dark"  >{{ $LANG('', '是') }}</el-tag>
                        <el-tag  v-else-if="item.key=='FCHK'&&scope.row['FCHK']!=='Y'" size="mini" type="info" effect="dark">{{ $LANG('', '否') }}</el-tag>
                        <el-checkbox v-else-if="item.edcss=='checkbox' && item.key!=='SEL'" disabled v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-checkbox :disabled="scope.row['FCHK']=='Y'" v-else-if="item.key=='SEL'" v-model="scope.row[item.key]" true-label="Y" false-label="N"></el-checkbox>
                        <el-link v-else-if="item.key=='FILEPATH'" :underline="false" >
                            <div v-if="scope.row[item.key] && scope.row[item.key].lastIndexOf('.pdf')>-1 ">
                                <div @click="imgPreview(scope.row[item.key])" slot="error"><i class="iconfont icon-pdf"></i></div>
                            </div>
                            <el-image v-else style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <el-link v-else-if="item.key=='OKAMT'" :underline="false" @click="okShow(scope.row)"><div style="color:#409eff;border-bottom:1px solid green;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>
                        <div v-else v-text="scope.row[item.key]" style="float:left"> </div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column
                fixed="right"
                :label="$LANG('', '操作')"
                align="center"
                width="70">
                <template slot-scope="scope">
                    <i class="iconfont icon-icon-chaolianjie" style="color:#409EFF;font-size:14px;margin-right:2px;"></i>
                    <el-link :disabled="scope.row['FCHK']!=='Y'" @click="attBtn(scope.row,scope.$index)" :underline="false" style="font-size:12px; "><span style="font-size:12px;margin-right:5px">{{ $LANG('', '附件') }}</span></el-link>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <h3 class="wb-reconcile-detail-title">{{ $LANG('0109', '明细资料') }}</h3>
        <el-table  :data="dtlData"
            border
            class="custom-table-border"
            size="small"
            ref="refdtl"
            show-summary
            :summary-method="getSummary"
            :cell-style="{padding:'2px'}"
            :height="detailHeight"
            highlight-current-row>
            <el-table-column :label="$LANG('', '序号')" type="index" width="65" ></el-table-column>
            <el-table-column  v-for="(item,index ) in perCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"
                :sortable="item.key!=='RN'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
            </el-table-column>
        </el-table>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :show-close="!saving" width="500px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div>
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;display:flex">
                <span style="padding-left:5px;font-size:12px;font-weight:600">{{ $LANG('', '基本信息') }}</span>
                <el-link @click="viewData" :underline="false" style="margin-left:15px;border-bottom:1px solid red;color:#389">{{ $LANG('', '速珀开票资料') }}</el-link>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '单据编码') }}</div>
                <el-input size="medium" disabled v-model="v_idno" style="width:100%;font-size:12px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '单据金额') }}</div>
                <el-input size="medium" disabled v-model="v_amt" style="width:100%;font-size:14px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '单据条数') }}</div>
                <el-input size="medium" disabled v-model="v_cnt" style="width:100%;font-size:14px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px;color:red">{{ $LANG('', '发票号码') }}</div>
                <el-input size="medium" v-model="v_finvno" style="width:100%;font-size:14px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px;color:red">{{ $LANG('', '发票金额') }}</div>
                <el-input-number size="medium" v-model="v_invamt" style="width:100%;font-size:14px"> </el-input-number>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px">{{ $LANG('', '对账日期') }}</div>
                <el-input disabled size="medium" v-model="v_dttm" style="width:100%;font-size:14px">  </el-input>
            </div>
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;margin-top:15px">
                <span style="padding-left:5px;font-size:12px;font-weight:600">{{ $LANG('', '上传发票附件') }}</span>
            </div>
            <Upload
                ref="upload"
                name="upfile"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeImgFile"
                :on-success="successImgFile"
                :with-credentials="true"
                :format="['jpg','jpeg','png','pdf' ]"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :on-progress="handleProgress"
                :action="uploadUrl"
                v-if="fileUrl.length<2"
                style="display: inline-block;width:200px; ">
                <div style="padding: 1px 0;width:200px;height:200px;">
                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image>
                    <p style="color:#515a6e;margin-top:5px;">{{ $LANG('', '将文件拖动此处或点击上传') }}</p>
                </div>
            </Upload>
            <div  v-if="fileUrl.length>2" >

                <div v-if="fileUrl.lastIndexOf('.pdf')>-1" style="width:200px;height:200px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="fileUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
                <el-image v-else-if="fileUrl.length>2"  :preview-src-list="[fileUrl]" fit="fill"  style="width:200px;height:200px;margin-right:30px;" :src="fileUrl"></el-image>
                <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                    <el-link  :underline="false" @click="imgDel(fileUrl)"><Icon type="md-close" />{{ $LANG('', '删除') }}</el-link>
                    <el-link v-if="fileUrl.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(fileUrl)"><Icon type="ios-search" />{{ $LANG('', '预览') }}</el-link>
                </div>

            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:10px ">
                <span style="float:right">
                    <el-button type="info" @click="addWin=false" :disabled="saving" size="small"  icon="iconfont icon-shanchu">{{ $LANG('', '取消') }}</el-button>
                    <el-button type="primary" @click="saveRec" :loading="saving" :disabled="saving" size="small" style="margin-left:30px" icon="iconfont icon-chenggong">{{ $LANG('', '确认') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('', '确 定') }}</el-button>
            </span>
        </el-dialog>

        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('', '报表预览') }}</span>
            </div>
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('', '预览') }}</span>
            </div>
            <div style="height:600px;overflow-y:auto">
                <el-image fit="scale-down"  style=" margin:5px auto; height:500px;width:100% " :preview-src-list="srcList" :src="listurl"></el-image>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('', '正在上传中...') }}</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="editWin" width="520px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('', '对账确认') }}</span>
            </div>

            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px">
                <span style="padding-left:5px;font-size:14px;font-weight:600;color:red">{{ $LANG('', '基本信息（ 提示：已对账 “ 未勾选 ” 时，确认后 会自动更新 发票号码为空 ）') }}</span>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '单据编码') }}</div>
                <el-input size="medium" disabled v-model="v_row['IDNO']" style="width:100%;font-size:12px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '单据金额') }}</div>
                <el-input size="medium" disabled v-model="v_row['AMT']" style="width:100%;font-size:14px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px;color:#409eff">{{ $LANG('', '已对账') }}</div>
                <el-checkbox size="medium" true-label="Y" false-label="N" border v-model="v_row['FCHK']" style="width:100%;font-size:14px"> </el-checkbox>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '发票号码') }}</div>
                <el-input size="medium"  disabled v-model="v_row['FINVNO']" style="width:100%;font-size:14px"> </el-input>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">{{ $LANG('', '发票金额') }}</div>
                <el-input-number disabled size="medium" v-model="v_row['INVAMT']" style="width:100%;font-size:14px"> </el-input-number>
            </div>
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px">{{ $LANG('', '对账日期') }}</div>
                <el-input disabled size="medium" v-model="v_row['FINDTTM']" style="width:100%;font-size:14px">  </el-input>
            </div>
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;margin-top:15px">
                <span style="padding-left:5px;font-size:12px;font-weight:600">{{ $LANG('', '发票附件') }}</span>
            </div>
            <Upload
                ref="upload"
                name="upfile"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeImgFile"
                :on-success="successImgFile"
                :with-credentials="true"
                :format="['jpg','jpeg','png','pdf' ]"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :on-progress="handleProgress"
                :action="uploadUrl"
                v-if="fileUrl.length<2"
                style="display: inline-block;width:200px; ">
                <div style="padding: 1px 0;width:200px;height:200px;">
                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image>
                    <p style="color:#515a6e;margin-top:5px;">{{ $LANG('', '将文件拖动此处或点击上传') }}</p>
                </div>
            </Upload>
            <div  v-if="fileUrl.length>2" >
                <div v-if="fileUrl.lastIndexOf('.pdf')>-1" style="width:200px;height:200px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="fileUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
                <el-image v-else-if="fileUrl.length>2"  :preview-src-list="[fileUrl]" fit="fill"  style="width:200px;height:200px;margin-right:30px;" :src="fileUrl"></el-image>
                <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                    <el-link  :underline="false" @click="imgDel(fileUrl)"><Icon type="md-close" />{{ $LANG('', '删除') }}</el-link>
                    <el-link v-if="fileUrl.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(fileUrl)"><Icon type="ios-search" />{{ $LANG('', '预览') }}</el-link>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:10px ">
                <span style="float:right">
                    <el-button type="info" @click="editWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('', '取消') }}</el-button>
                    <el-button type="primary" @click="attSave" size="small" style="margin-left:30px" icon="iconfont icon-chenggong">{{ $LANG('', '确认') }}</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ReconcilePage from '@/views/srmmgt/po_paychk.vue'
import { getTabColOrData } from '@/api/user'
import { getDate } from '@/api/Select'

function createReconcileOptions(component) {
  const source = component.options || component
  const page = {
    ...source,
    workbenchReconcile: true,
    data() { return { ...source.data.call(this), saving: false, queryEpoch: 0, loadWin:false } },
    computed: {
      ...source.computed,
      tabHeight() { return Math.max(100, (this.workbenchHeight || 500) - this.detailHeight - 118) },
      allList() { return this.tabData },
      detailHeight() { return Math.min(180, Math.max(90, (this.workbenchHeight || 500) * .25)) }
    },
    methods: {
      ...source.methods,
      selChg() { this.tabData.forEach(row => { row.SEL = row.FCHK === 'Y' ? 'N' : this.v_select }) },
      editRec() {
        this.tabData.forEach(row => { if (row.FCHK === 'Y') row.SEL = 'N' })
        source.methods.editRec.call(this)
        if (this.promptWin) this.prompt = this.$LANG('', this.prompt)
      },
      qryTabData() {
        let condition = ''
        const fields = this.payCol
        if (!['Y', 'N', 'ALL'].includes(this.stfg_)) return
        if (this.stfg_ !== 'ALL') condition += " and fchk='" + this.stfg_ + "'"
        if (this.txtparam && fields.some(field => field.key === this.selparam) && ['like','=','!=','>','<','>=','<='].includes(this.oper)) {
          const value = String(this.txtparam).replace(/'/g, "''")
          condition += this.oper === 'like' ? ` and ${this.selparam} like '%${value}%'` : ` and ${this.selparam}${this.oper}'${value}'`
        }
        let invalid = false
        fields.forEach(field => {
          const raw = this.v_inputrow[field.key]
          if (raw === '' || raw == null || field.key === 'SEL') return
          const value = String(raw).trim().replace(/'/g, "''")
          if (field.edcss === 'number') {
            if (!/^-?\d+(\.\d+)?$/.test(value)) { invalid = true; return }
            condition += ` and ${field.key}>=${value}`
          } else if (field.key === 'FCHK') {
            if (['Y','N'].includes(value)) condition += ` and FCHK='${value}'`
          } else condition += ` and ${field.key} like '%${value}%'`
        })
        if (invalid) { this.promptWin = true; this.prompt = this.$LANG('', '请输入有效数字'); return }
        this.current = 1
        return this.getOrdList(condition)
      },
      async getOrdList(condition) {
        const epoch = ++this.queryEpoch
        this.v_loading = true
        let scope = " and idty in ('POIN','PRDIN','PORTN')"
        if (this.v_oth === 'Y') scope += " and supno in (select idno from V_bs_sup where PHONENO='" + String(this.v_username).replace(/'/g,"''") + "')"
        const sort = this.payCol.some(field => field.key === this.selparam) ? this.selparam : 'IDNO'
        try {
          const res = await this.$axios({ method:'post', url:'xuper_auth/getBaseData', data:{p_key:'corpid',p_value:this.v_corpid,p_table:'V_IC_STKCHK',p_cond:scope+condition+" and stfg='Y' order by "+sort+' desc'} })
          if (epoch !== this.queryEpoch || this._isDestroyed) return
          if (String(res.code) !== '200' || !Array.isArray(res.result)) throw new Error(res.result || this.$LANG('', '查询失败'))
          this.allData = res.result.map(row => ({...row, SEL:'N'}))
          this.v_select = 'N'
          this.initPage()
          this.$nextTick(() => {
            if (this._isDestroyed) return
            if (this.$refs.tabref) this.$refs.tabref.doLayout()
            if (this.tabData.length) {
              this.$refs.tabref.setCurrentRow(this.tabData[0])
              this.getDtlData(this.tabData[0].IDSEQ,this.tabData[0].REFTY)
            } else this.dtlData = []
          })
        } catch (error) {
          if (epoch === this.queryEpoch && !this._isDestroyed) { this.promptWin = true; this.prompt = error.message }
        } finally { if (epoch === this.queryEpoch) this.v_loading = false }
      },
      changePage(index) { this.current = index; this.v_select = 'N'; this.allData.forEach(row => { row.SEL = 'N' }); return source.methods.changePage.call(this,index) },
      async saveRec() {
        if (this.saving) return
        let error = ''
        if (!this.v_finvno) error = '发票号码不能为空'
        else if (!this.v_invamt) error = '发票金额不能为空'
        else if (Math.floor(Number(this.v_invamt)) !== Math.floor(Number(this.v_amt))) error = '发票金额与单据金额不相等'
        else if (this.fileUrl === 'N' && !['无','已开'].includes(this.v_finvno)) error = '请上传发票'
        else if (!this.v_data.length) error = '请选择需要对账的单据'
        if (error) { this.promptWin = true; this.prompt = this.$LANG('',error); return }
        this.saving = true
        const escape = value => String(value || '').replace(/'/g,"''")
        const amount = Number(this.v_invamt)
        if (!Number.isFinite(amount)) { this.saving = false; this.promptWin = true; this.prompt = this.$LANG('', '请输入有效数字'); return }
        const cond = " set FLAG='ADMIN',FINVNO='"+escape(this.v_finvno)+"',FCHK='Y',findttm='"+getDate('full')+"',invamt="+amount+",filepath='"+escape(this.fileUrl==='N'?'':this.fileUrl)+"',naspath='"+escape(this.v_filePath)+"'"
        try {
          const results = await Promise.all(this.v_data.map(row => this.$axios({method:'post',url:'xuper_auth/updateRec',data:{p_key:'idseq',p_value:row.IDSEQ,p_table:row.REFTY==='POFEE'?'PO_ORD':'ic_stk',p_cond:cond}}).then(res=>({ok:String(res.code)==='200',error:res.result}),error=>({ok:false,error:error.message}))))
          if (this._isDestroyed) return
          const failed = results.find(result => !result.ok)
          if (failed) { this.promptWin = true; this.prompt = this.$LANG('', '对账未全部成功，请核对后重试')+'：'+failed.error }
          else this.addWin = false
          await this.qryTabData()
        } catch (error) {
          if (!this._isDestroyed) { this.promptWin = true; this.prompt = this.$LANG('', '对账结果未确认，请刷新核对')+'：'+error.message }
        } finally { this.saving = false }
      },

      getTabField() {
        return Promise.all([['2060','perCol'],['2062','payCol']].map(([list,key])=>getTabColOrData(this.v_url,'v_sys_form_fld','idseq','397193','lstseq',list,'','',' order by sortby,itmseq').then(res=>{
          if (this._isDestroyed) return
          if (String(res.code)!=='200' || !Array.isArray(res.result)) throw new Error(res.result || this.$LANG('', '加载字段失败'))
          this[key]=res.result.map(field=>({title:this.$translate.getColTitle(field,this.$store.state.lang),key:field.key,align:field.align,width:field.width,thide:field.THIDE,fhide:field.FHIDE,edcss:field.EDCSS,disabled:field.DISABLED,dotnum:field.DOTNUM,sortable:field.SORTABLE,notnull:field.NOTNULL}))
        }))).catch(error=>{ this.promptWin=true; this.prompt=error.message })
      }
    }
  }
  delete page._Ctor; delete page.render; delete page.staticRenderFns; delete page._scopeId
  return page
}

export default createReconcileOptions(ReconcilePage)
</script>
<style scoped>
.wb-reconcile-section{display:flex;flex-direction:column;flex:1;min-height:0;height:100%;overflow:hidden;background:#fff;color:#334155;font-size:12px}
.suppo-reconcile-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-width: 1000px;
    height: 40px !important;
    min-height: 40px !important;
    padding: 4px 8px !important;
    background: #fff;
    line-height: normal;
    border-bottom: 1px solid #e2e8f0;
    box-sizing: border-box;
    flex-shrink: 0;
}
.toolbar-left-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}
.suppo-reconcile-toolbar ::v-deep .el-button {
    height: 30px !important;
    line-height: 30px !important;
    padding: 0 12px !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.suppo-reconcile-toolbar ::v-deep .el-button [class*="icon-"] {
    font-size: 13px;
    margin-right: 4px;
}
.wb-reconcile-section ::v-deep .el-button--primary{background:#2563eb;border-color:#2563eb}
.wb-reconcile-main{flex:1 1 0;min-height:0}
.wb-reconcile-section>.el-table:not(.wb-reconcile-main){flex-shrink:0}
.wb-reconcile-section>div[style*="margin-top: 3px"]{flex-shrink:0;min-height:40px;align-items:center;padding:3px 8px;border-top:1px solid #e2e8f0}
.wb-reconcile-detail-title {
    display: flex;
    flex: 0 0 32px;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    width: 100%;
    height: 32px;
    margin: 0;
    padding: 0 12px;
    border-top: 1px solid #e2e8f0;
    border-left: 4px solid #cc0000;
    background: #f8fafc;
    color: #475569;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
}
.wb-reconcile-section ::v-deep .el-table th{background:#f8fafc;color:#64748b;font-size:12px}
.wb-reconcile-section ::v-deep .el-table td{font-size:12px}
</style>
